import { render, staticRenderFns } from "./douyin-bind.vue?vue&type=template&id=cf058100&scoped=true&"
import script from "./douyin-bind.vue?vue&type=script&lang=js&"
export * from "./douyin-bind.vue?vue&type=script&lang=js&"
import style0 from "./douyin-bind.vue?vue&type=style&index=0&id=cf058100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf058100",
  null
  
)

export default component.exports